exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-blue[data-v-4d45bb41] {\n  color: #23b7e5\n}\n", ""]);

// exports
